/**
 * Translation mappings for codelist descriptions
 * Maps German descriptions to English translations
 */

// Country name translations (German -> English)
export const COUNTRY_TRANSLATIONS: Record<string, string> = {
  // EU Countries
  'Österreich': 'Austria',
  'Belgien': 'Belgium',
  'Bulgarien': 'Bulgaria',
  'Zypern': 'Cyprus',
  'Tschechien': 'Czech Republic',
  'Deutschland': 'Germany',
  'Dänemark': 'Denmark',
  'Estland': 'Estonia',
  'Spanien': 'Spain',
  'Finnland': 'Finland',
  'Frankreich': 'France',
  'Griechenland': 'Greece',
  'Kroatien': 'Croatia',
  'Ungarn': 'Hungary',
  'Irland': 'Ireland',
  'Italien': 'Italy',
  'Litauen': 'Lithuania',
  'Luxemburg': 'Luxembourg',
  'Lettland': 'Latvia',
  'Malta': 'Malta',
  'Niederlande': 'Netherlands',
  'Polen': 'Poland',
  'Portugal': 'Portugal',
  'Rumänien': 'Romania',
  'Schweden': 'Sweden',
  'Slowenien': 'Slovenia',
  'Slowakei': 'Slovakia',
  'Vereinigtes Königreich (Nordirland)': 'United Kingdom (Northern Ireland)',
  'Vereinigtes Königreich': 'United Kingdom',

  // Major non-EU countries
  'Vereinigte Staaten': 'United States',
  'Vereinigte Staaten von Amerika': 'United States of America',
  'China': 'China',
  'Japan': 'Japan',
  'Indien': 'India',
  'Russland': 'Russia',
  'Russische Föderation': 'Russian Federation',
  'Kanada': 'Canada',
  'Australien': 'Australia',
  'Brasilien': 'Brazil',
  'Mexiko': 'Mexico',
  'Südkorea': 'South Korea',
  'Korea, Republik': 'South Korea',
  'Schweiz': 'Switzerland',
  'Norwegen': 'Norway',
  'Island': 'Iceland',
  'Türkei': 'Turkey',
  'Südafrika': 'South Africa',
  'Ägypten': 'Egypt',
  'Israel': 'Israel',
  'Neuseeland': 'New Zealand',
  'Singapur': 'Singapore',
  'Hongkong': 'Hong Kong',
  'Taiwan': 'Taiwan',
  'Thailand': 'Thailand',
  'Vietnam': 'Vietnam',
  'Indonesien': 'Indonesia',
  'Malaysia': 'Malaysia',
  'Philippinen': 'Philippines',
  'Saudi-Arabien': 'Saudi Arabia',
  'Vereinigte Arabische Emirate': 'United Arab Emirates',
  'Katar': 'Qatar',
  'Kuwait': 'Kuwait',
  'Argentinien': 'Argentina',
  'Chile': 'Chile',
  'Kolumbien': 'Colombia',
  'Peru': 'Peru',
  'Ukraine': 'Ukraine',
  'Weißrussland': 'Belarus',
  'Serbien': 'Serbia',
  'Marokko': 'Morocco',
  'Tunesien': 'Tunisia',
  'Nigeria': 'Nigeria',
  'Kenia': 'Kenya',
  'Pakistan': 'Pakistan',
  'Bangladesch': 'Bangladesh',
  'Iran': 'Iran',
  'Irak': 'Iraq',
};

// Currency translations (German -> English)
export const CURRENCY_TRANSLATIONS: Record<string, string> = {
  'Dirham': 'Dirham',
  'Afghani': 'Afghani',
  'Lek': 'Lek',
  'Dram': 'Dram',
  'Kwanza': 'Kwanza',
  'Argentinischer Peso': 'Argentine Peso',
  'Australischer Dollar': 'Australian Dollar',
  'Aruba-Florin': 'Aruban Florin',
  'Aserbaidschan-Manat': 'Azerbaijani Manat',
  'Konvertible Mark': 'Convertible Mark',
  'Barbados-Dollar': 'Barbados Dollar',
  'Taka': 'Taka',
  'Bulgarische Lew': 'Bulgarian Lev',
  'Bahrain-Dinar': 'Bahraini Dinar',
  'Burundi-Franc': 'Burundi Franc',
  'Bermuda-Dollar': 'Bermuda Dollar',
  'Brunei-Dollar': 'Brunei Dollar',
  'Boliviano': 'Boliviano',
  'Mvdol': 'Mvdol',
  'Brasilianischer Real': 'Brazilian Real',
  'Euro': 'Euro',
  'US-Dollar': 'US Dollar',
  'Britisches Pfund': 'British Pound',
  'Pfund Sterling': 'Pound Sterling',
  'Schweizer Franken': 'Swiss Franc',
  'Japanischer Yen': 'Japanese Yen',
  'Chinesischer Yuan': 'Chinese Yuan',
  'Chinesischer Renminbi': 'Chinese Renminbi',
  'Kanadischer Dollar': 'Canadian Dollar',
  'Indische Rupie': 'Indian Rupee',
  'Russischer Rubel': 'Russian Ruble',
  'Südkoreanischer Won': 'South Korean Won',
  'Mexikanischer Peso': 'Mexican Peso',
  'Türkische Lira': 'Turkish Lira',
  'Südafrikanischer Rand': 'South African Rand',
  'Norwegische Krone': 'Norwegian Krone',
  'Schwedische Krone': 'Swedish Krona',
  'Dänische Krone': 'Danish Krone',
  'Polnischer Zloty': 'Polish Zloty',
  'Tschechische Krone': 'Czech Koruna',
  'Ungarischer Forint': 'Hungarian Forint',
  'Rumänischer Leu': 'Romanian Leu',
  'Israelischer Schekel': 'Israeli Shekel',
  'Neuer Israelischer Schekel': 'New Israeli Shekel',
  'Singapur-Dollar': 'Singapore Dollar',
  'Hongkong-Dollar': 'Hong Kong Dollar',
  'Neuseeländischer Dollar': 'New Zealand Dollar',
  'Saudi-Riyal': 'Saudi Riyal',
  'VAE-Dirham': 'UAE Dirham',
  'Ägyptisches Pfund': 'Egyptian Pound',
  'Thailändischer Baht': 'Thai Baht',
  'Malaysischer Ringgit': 'Malaysian Ringgit',
  'Indonesische Rupiah': 'Indonesian Rupiah',
  'Philippinischer Peso': 'Philippine Peso',
  'Vietnamesischer Dong': 'Vietnamese Dong',
  'Pakistanische Rupie': 'Pakistani Rupee',
};

// Transport mode translations (German -> English)
export const TRANSPORT_MODE_TRANSLATIONS: Record<string, string> = {
  'Seeverkehr': 'Sea transport',
  'Schienenverkehr': 'Rail transport',
  'Eisenbahnverkehr': 'Rail transport',
  'Straßenverkehr': 'Road transport',
  'Luftverkehr': 'Air transport',
  'Postverkehr': 'Mail',
  'Rohrfernleitung': 'Pipeline transport',
  'Binnenwasserstraßen': 'Inland waterway transport',
  'Eigener Antrieb': 'Self-propulsion',
  'See': 'Sea',
  'Schiene': 'Rail',
  'Straße': 'Road',
  'Luft': 'Air',
  'Post': 'Mail',
  'Nicht bekannt': 'Unknown',
  'Nicht verfügbar': 'Not available',
};

// Transport identification type translations (C0219 - artderIdentifikation)
export const TRANSPORT_ID_TYPE_TRANSLATIONS: Record<string, string> = {
  'IMO-Schiffnummer': 'IMO ship number',
  'Name des Seeschiffs': 'Name of sea vessel',
  'Zugnummer': 'Train number',
  'Amtliches Kennzeichen des Straßenfahrzeugs': 'Official registration of road vehicle',
  'Europäische Binnenschifffahrtsnummer (ENI-Code)': 'European vessel identification number (ENI)',
  'Flugnummer': 'Flight number',
};

// Location type translations (A0090 / S0347)
export const LOCATION_TYPE_TRANSLATIONS: Record<string, string> = {
  'Bestimmter Ort': 'Designated location',
  'Bewilligter Ort': 'Approved location',
  'Anderer Ort': 'Other location',
};

// Location determination type translations (A0091 / S0326)
export const LOCATION_DET_TYPE_TRANSLATIONS: Record<string, string> = {
  'UN/LOCODE': 'UN/LOCODE',
  'Zollstelle': 'Customs office',
  'GNSS-Koordinaten': 'GNSS coordinates',
  'Bewilligung': 'Authorisation',
  'Adresse': 'Address',
};

// Security indicator translations (C0217)
export const SECURITY_INDICATOR_TRANSLATIONS: Record<string, string> = {
  'Enthält keine Daten einer summ. Eingangs- oder Ausgangsanmeldung': 'Does not contain data from a summary entry/exit declaration',
  'Enthält die Daten einer summarischen Ausgangsanmeldung': 'Contains data from a summary exit declaration',
  'Enthält die Daten einer summarischen Eingangsanmeldung': 'Contains data from a summary entry declaration',
  'Enthält Daten sowohl einer summ. Eingangs- als auch Ausgangsanmeldung': 'Contains data from both entry and exit summary declarations',
};

// Payment method translations (C0024)
export const PAYMENT_METHOD_TRANSLATIONS: Record<string, string> = {
  'Barzahlung': 'Cash payment',
  'Kreditkarte': 'Credit card',
  'Scheck': 'Cheque',
  'Andere': 'Other',
  'Unbekannt': 'Unknown',
};

// Participant constellation (A0047 / A0127)
export const PARTICIPANT_CONSTELLATION_TRANSLATIONS: Record<string, string> = {
  'Außenwirtschaftsrechtlicher Ausführer ist (zollrechtlicher) Ausführer. Anmelder ist Ausführer. Anmelder lässt sich nicht direkt vertreten. Ausführer beauftragt keinen Subunternehmer.':
    'Foreign trade law exporter = customs law exporter. Declarant = exporter. No direct representation. No subcontractor.',
  'Außenwirtschaftsrechtlicher Ausführer ist (zollrechtlicher) Ausführer. Anmelder ist Ausführer. Anmelder lässt sich nicht direkt vertreten. Ausführer beauftragt Subunternehmer.':
    'Foreign trade law exporter = customs law exporter. Declarant = exporter. No direct representation. Subcontractor assigned.',
  'Außenwirtschaftsrechtlicher Ausführer ist (zollrechtlicher) Ausführer. Anmelder ist Ausführer. Anmelder lässt sich direkt vertreten. Ausführer beauftragt keinen Subunternehmer.':
    'Foreign trade law exporter = customs law exporter. Declarant = exporter. Direct representation. No subcontractor.',
  'Außenwirtschaftsrechtlicher Ausführer ist (zollrechtlicher) Ausführer. Anmelder ist Ausführer. Anmelder lässt sich direkt vertreten. Ausführer beauftragt Subunternehmer.':
    'Foreign trade law exporter = customs law exporter. Declarant = exporter. Direct representation. Subcontractor assigned.',
};

// Export declaration type (A0121) — short labels
export const EXPORT_DECL_TYPE_TRANSLATIONS: Record<string, string> = {
  'Standard-Ausfuhranmeldung zum zweistufigen Normalverfahren': 'Standard export declaration (two-stage normal procedure)',
  'Vereinfachte Ausfuhranmeldung zum zweistufigen Normalverfahren': 'Simplified export declaration (two-stage normal procedure)',
  'Standard-Ausfuhranmeldung zum zweistufigen Normalverfahren unter Verwendung einer Bewilligung CCL-Ausfuhr': 'Standard export declaration (two-stage normal procedure, CCL-Export authorisation)',
  'Standard-Ausfuhranmeldung zum zweistufigen Normalverfahren mit Antrag auf Gestellung außerhalb des Amtsplatzes nach §12(4) AWV': 'Standard export declaration (two-stage normal procedure, presentation outside customs premises)',
  'Standard-Ausfuhranmeldung zum einstufigen Verfahren bei Waren mit einem Wert bis 3.000 EUR': 'Standard export declaration (one-stage procedure, goods up to EUR 3,000)',
  'Standard-Ausfuhranmeldung zum einstufigen Verfahren in begründeten Fällen': 'Standard export declaration (one-stage procedure, justified cases)',
  'Standard-Ausfuhranmeldung zum zweistufigen Vereinfachten Verfahren unter Verwendung einer Bewilligung SDE-Ausfuhr': 'Standard export declaration (two-stage simplified procedure, SDE-Export authorisation)',
  'Vereinfachte Ausfuhranmeldung zum zweistufigen Vereinfachten Verfahren unter Verwendung einer Bewilligung SDE-Ausfuhr': 'Simplified export declaration (two-stage simplified procedure, SDE-Export authorisation)',
  'Vereinfachte Ausfuhranmeldung zum zweistufigen Vereinfachten Verfahren unter Verwendung von Bewilligungen SDE-Ausfuhr und CCL-Ausfuhr': 'Simplified export declaration (two-stage simplified procedure, SDE + CCL authorisations)',
  'Standard-Ausfuhranmeldung zum zweistufigen Normalverfahren unter Verwendung einer Bewilligung OPO-PV': 'Standard export declaration (two-stage normal procedure, OPO-PV authorisation)',
};

// Identification type (A1150)
export const IDENTIFICATION_TYPE_TRANSLATIONS: Record<string, string> = {
  'Geschäfte mit tatsächlicher Eigentumsübertragung bei finanzieller Gegenleistung': 'Transactions involving actual transfer of ownership against financial compensation',
  'Endgültiger Kauf/Verkauf, ausgenommen direkter Handel mit/durch private(n) Verbraucher(n)': 'Outright purchase/sale, except direct trade with/by private consumers',
  'Direkter Handel mit/durch private(n) Verbraucher(n), einschließlich Fernverkauf': 'Direct trade with/by private consumers, including distance selling',
};

// Transport cost payment method (C0024)
export const TRANSPORT_COST_TRANSLATIONS: Record<string, string> = {
  'Barzahlung': 'Cash',
  'Kreditkarte': 'Credit card',
  'Überweisung': 'Bank transfer',
  'Vorauszahlung': 'Advance payment',
};

// Declaration type (C0231)
export const DECL_TYPE_TRANSLATIONS: Record<string, string> = {
  'Ausfuhr oder Wiederausfuhr von Gütern außerhalb des Zollgebiets der Union': 'Export or re-export of goods outside the customs territory of the Union',
  'Handel von Unionsgütern zwischen Zollgebieten, welche nicht von den Verordnungen 2006/112/EC oder 2008/118/EC erfasst sind.': 'Trade in Union goods between customs territories not covered by Regulations 2006/112/EC or 2008/118/EC.',
};

// Container indicator (S0027)
export const CONTAINER_INDICATOR_TRANSLATIONS: Record<string, string> = {
  'ja': 'Yes',
  'nein': 'No',
  'Ja': 'Yes',
  'Nein': 'No',
  'Container': 'Container',
  'Kein Container': 'No Container',
};

// Incoterms translations (German -> English)
export const INCOTERMS_TRANSLATIONS: Record<string, string> = {
  'Ab Werk': 'Ex Works',
  'Frei Frachtführer': 'Free Carrier',
  'Frei längsseits Schiff': 'Free Alongside Ship',
  'Frei an Bord': 'Free On Board',
  'Kosten und Fracht': 'Cost and Freight',
  'Kosten, Versicherung und Fracht': 'Cost, Insurance and Freight',
  'Frachtfrei bis': 'Carriage Paid To',
  'Frachtfrei versichert bis': 'Carriage and Insurance Paid To',
  'Geliefert an Grenze': 'Delivered at Frontier',
  'Geliefert ab Schiff': 'Delivered Ex Ship',
  'Geliefert ab Kai': 'Delivered Ex Quay',
  'Geliefert unverzollt': 'Delivered Duty Unpaid',
  'Geliefert verzollt': 'Delivered Duty Paid',
  'Geliefert benannter Ort': 'Delivered at Place',
  'Geliefert benannter Ort entladen': 'Delivered at Place Unloaded',
  'Geliefert benanntes Terminal': 'Delivered at Terminal',
};

// Declaration type translations
export const DECLARATION_TYPE_TRANSLATIONS: Record<string, string> = {
  'Normale Ausfuhranmeldung': 'Normal Export Declaration',
  'Vereinfachte Ausfuhranmeldung': 'Simplified Export Declaration',
  'Ausfuhranmeldung mit Mitteilung': 'Export Declaration with Notification',
  'Wiederausfuhr': 'Re-export',
  'Passive Veredelung': 'Outward Processing',
  'Ausfuhr': 'Export',
  'Standardausfuhr': 'Standard Export',
};

// Container indicator translations
export const CONTAINER_TRANSLATIONS: Record<string, string> = {
  'Ja': 'Yes',
  'Nein': 'No',
  'Container': 'Container',
  'Kein Container': 'No Container',
};

// Security indicator translations
export const SECURITY_TRANSLATIONS: Record<string, string> = {
  'Keine Sicherheitsdaten': 'No security data',
  'Summarische Eingangsanmeldung': 'Entry Summary Declaration',
  'Summarische Ausgangsanmeldung': 'Exit Summary Declaration',
  'Keine summarische Anmeldung erforderlich': 'No summary declaration required',
};

// Special circumstances translations
export const SPECIAL_CIRCUMSTANCES_TRANSLATIONS: Record<string, string> = {
  'Keine': 'None',
  'Dringend': 'Urgent',
  'Notfall': 'Emergency',
};

// Generic function to translate a German description to English
export function translateDescription(germanText: string, codelistId?: string): string {
  if (!germanText) return germanText;

  // Try specific codelist translations first (most precise)
  if (codelistId) {
    // Country codelists
    if (['C0248', 'C0010', 'C0008', 'C0165'].includes(codelistId)) {
      return COUNTRY_TRANSLATIONS[germanText] || germanText;
    }
    // Also try C0021 countries (nationality)
    if (codelistId === 'C0021') {
      return COUNTRY_TRANSLATIONS[germanText] || germanText;
    }
    // Currency codelists
    if (codelistId === 'C0352' || codelistId === 'C0013') {
      return CURRENCY_TRANSLATIONS[germanText] || germanText;
    }
    // Transport mode (border / inland)
    if (['C0018', 'C0019'].includes(codelistId)) {
      return TRANSPORT_MODE_TRANSLATIONS[germanText] || germanText;
    }
    // Transport identification type (at departure)
    if (['C0219', 'C0020'].includes(codelistId)) {
      return TRANSPORT_ID_TYPE_TRANSLATIONS[germanText] || TRANSPORT_MODE_TRANSLATIONS[germanText] || germanText;
    }
    // Incoterms
    if (codelistId === 'C0090') {
      return INCOTERMS_TRANSLATIONS[germanText] || germanText;
    }
    // Container indicator
    if (codelistId === 'S0027') {
      return CONTAINER_INDICATOR_TRANSLATIONS[germanText] || CONTAINER_TRANSLATIONS[germanText] || germanText;
    }
    // Security indicator
    if (codelistId === 'C0217' || codelistId === 'A0049') {
      return SECURITY_INDICATOR_TRANSLATIONS[germanText] || SECURITY_TRANSLATIONS[germanText] || germanText;
    }
    // Location type (Warenort Art des Ortes)
    if (['A0090', 'S0347'].includes(codelistId)) {
      return LOCATION_TYPE_TRANSLATIONS[germanText] || germanText;
    }
    // Location determination type (Warenort Art der Ortsbestimmung)
    if (['A0091', 'S0326'].includes(codelistId)) {
      return LOCATION_DET_TYPE_TRANSLATIONS[germanText] || germanText;
    }
    // Export declaration type
    if (codelistId === 'A0121') {
      return EXPORT_DECL_TYPE_TRANSLATIONS[germanText] || DECLARATION_TYPE_TRANSLATIONS[germanText] || germanText;
    }
    // Declaration type (Art der Anmeldung)
    if (codelistId === 'C0231') {
      return DECL_TYPE_TRANSLATIONS[germanText] || DECLARATION_TYPE_TRANSLATIONS[germanText] || germanText;
    }
    // Participant constellation
    if (['A0047', 'A0127'].includes(codelistId)) {
      return PARTICIPANT_CONSTELLATION_TRANSLATIONS[germanText] || germanText;
    }
    // Identification type
    if (['A0089', 'A1150'].includes(codelistId)) {
      return IDENTIFICATION_TYPE_TRANSLATIONS[germanText] || germanText;
    }
    // Payment method
    if (codelistId === 'C0024') {
      return TRANSPORT_COST_TRANSLATIONS[germanText] || PAYMENT_METHOD_TRANSLATIONS[germanText] || germanText;
    }
    // Special circumstances
    if (codelistId === 'C0025') {
      return SPECIAL_CIRCUMSTANCES_TRANSLATIONS[germanText] || germanText;
    }
  }

  // Fallback: try all translation maps in order of specificity
  return EXPORT_DECL_TYPE_TRANSLATIONS[germanText]
    || LOCATION_TYPE_TRANSLATIONS[germanText]
    || LOCATION_DET_TYPE_TRANSLATIONS[germanText]
    || SECURITY_INDICATOR_TRANSLATIONS[germanText]
    || TRANSPORT_ID_TYPE_TRANSLATIONS[germanText]
    || PARTICIPANT_CONSTELLATION_TRANSLATIONS[germanText]
    || IDENTIFICATION_TYPE_TRANSLATIONS[germanText]
    || DECL_TYPE_TRANSLATIONS[germanText]
    || DECLARATION_TYPE_TRANSLATIONS[germanText]
    || INCOTERMS_TRANSLATIONS[germanText]
    || TRANSPORT_MODE_TRANSLATIONS[germanText]
    || COUNTRY_TRANSLATIONS[germanText]
    || CURRENCY_TRANSLATIONS[germanText]
    || CONTAINER_INDICATOR_TRANSLATIONS[germanText]
    || CONTAINER_TRANSLATIONS[germanText]
    || SECURITY_TRANSLATIONS[germanText]
    || PAYMENT_METHOD_TRANSLATIONS[germanText]
    || TRANSPORT_COST_TRANSLATIONS[germanText]
    || SPECIAL_CIRCUMSTANCES_TRANSLATIONS[germanText]
    || germanText;
}

// Get bilingual description (German / English)
export function getBilingualDescription(germanText: string, codelistId?: string): string {
  if (!germanText) return germanText;

  const englishText = translateDescription(germanText, codelistId);

  // If translation found and different from original, show both
  if (englishText && englishText !== germanText) {
    return `${englishText} / ${germanText}`;
  }

  return germanText;
}

// Get description in specific language
export function getLocalizedDescription(germanText: string, language: string, codelistId?: string): string {
  if (!germanText) return germanText;

  if (language === 'de') {
    return germanText;
  }

  // For English or other languages, try to translate
  const englishText = translateDescription(germanText, codelistId);
  return englishText || germanText;
}
